// extracted by mini-css-extract-plugin
export default {"container":"style_container__sb8Kh","itemContainer":"style_itemContainer__zaLBR","currency":"style_currency__Ngg-D","money":"style_money__nBT6a"};